'use strict'

import React from 'react'

export default class Footer2 extends React.Component {
  click () {
    window.ga('send', 'event', {
      eventCategory: 'Phone',
      eventAction: 'Click',
      eventLabel: 'Click'
    })
  }

  render () {
    return (
      <div className='footer footer2'>
        <div className='container'>
          <br />
          <img src='assets/images/ADA.jpg' />
          <br />
          The Australian Dental Association is an organisation of dentists which has as its aim the
          encouragement of the health of the public and the promotion of the art and science of dentistry.
          This membership implies an obligation for members to practise their profession in accordance
          with the high standards laid down by the Association.
          <br />
          <h1>
            <a
              onClick={this.click.bind(this)}
              className='call-us'
              href='tel:1300787356'>
              Call Us 1300 787 356
            </a>
          </h1>
          <p>
            Monday - Friday 8:00am to 6:00pm AEDT
          </p>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/assets/footer2.js